import { useMemo } from 'react';
import { useAppSelector, editorState } from 'src/store';

export const useEditorState = () => {
  const {
    editorType,
    codeEditorData,
    isWordWrapEnabled,
    isEditorDarkTheme,
    isEditorStreaming,
    autoSavingStatus,
  } = useAppSelector(editorState);

  return useMemo(
    () => ({
      isAutoSavingError: autoSavingStatus === 'error',
      isAutoSavingLoading: autoSavingStatus === 'loading',
      isAutoSavingSuccess: autoSavingStatus === 'success',
      isEditorDarkTheme,
      editorType,
      codeEditorData,
      isWordWrapEnabled,
      isEditorStreaming,
    }),
    [
      autoSavingStatus,
      isEditorDarkTheme,
      editorType,
      codeEditorData,
      isWordWrapEnabled,
      isEditorStreaming,
    ],
  );
};
